import { render, staticRenderFns } from "./AndroidLogo.vue?vue&type=template&id=07c2d7b8&"
import script from "./AndroidLogo.vue?vue&type=script&lang=ts&"
export * from "./AndroidLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07c2d7b8')) {
      api.createRecord('07c2d7b8', component.options)
    } else {
      api.reload('07c2d7b8', component.options)
    }
    module.hot.accept("./AndroidLogo.vue?vue&type=template&id=07c2d7b8&", function () {
      api.rerender('07c2d7b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/icons/AndroidLogo.vue"
export default component.exports